module.exports = __webpack_public_path__ + "assets/22786f243202d7912399ffd10c76fe78.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-400-normal.woff2
// module id = 2627
// module chunks = 121